const LotIcon = (props: any) => {
    return <img {...props} alt="lots.png" src={require('./lots.png')} />;
};

export default LotIcon;
